import { render, staticRenderFns } from "./Epic.vue?vue&type=template&id=395c0427&scoped=true"
import script from "./Epic.vue?vue&type=script&lang=js"
export * from "./Epic.vue?vue&type=script&lang=js"
import style0 from "./Epic.vue?vue&type=style&index=0&id=395c0427&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395c0427",
  null
  
)

export default component.exports